var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __decorateClass = (decorators, target, key, kind) => {
  var result = kind > 1 ? void 0 : kind ? __getOwnPropDesc(target, key) : target;
  for (var i = decorators.length - 1, decorator; i >= 0; i--)
    if (decorator = decorators[i])
      result = (kind ? decorator(target, key, result) : decorator(result)) || result;
  if (kind && result)
    __defProp(target, key, result);
  return result;
};
var __accessCheck = (obj, member, msg) => {
  if (!member.has(obj))
    throw TypeError("Cannot " + msg);
};
var __privateGet = (obj, member, getter) => {
  __accessCheck(obj, member, "read from private field");
  return getter ? getter.call(obj) : member.get(obj);
};
var __privateAdd = (obj, member, value) => {
  if (member.has(obj))
    throw TypeError("Cannot add the same private member more than once");
  member instanceof WeakSet ? member.add(obj) : member.set(obj, value);
};
var __privateSet = (obj, member, value, setter) => {
  __accessCheck(obj, member, "write to private field");
  setter ? setter.call(obj, value) : member.set(obj, value);
  return value;
};
var __privateMethod = (obj, member, method) => {
  __accessCheck(obj, member, "access private method");
  return method;
};
var _boundBackdropClick, _boundKeydown, _emit, _handleKeydown, handleKeydown_fn, _handleBackdropClick, handleBackdropClick_fn;
import { LitElement, html, nothing } from "@horizon/base";
import { query, property } from "@horizon/base/decorators";
import { classMap } from "@horizon/base/directives";
import { ScopedElementsMixin } from "@open-wc/scoped-elements/lit-element.js";
import { eventEmitter } from "@horizon/common/events";
import { injectScrollLockStyles } from "@horizon/common/helpers";
import { HznHeading } from "@horizon/heading";
import { HznIconButton } from "@horizon/icon-button";
import { HznIconClose } from "@horizon/icons/individual";
import ModalStyles from "./modal.css.js";
class HznModal extends ScopedElementsMixin(LitElement) {
  constructor() {
    super();
    /**
     * @private
     */
    __privateAdd(this, _handleKeydown);
    /**
     * @private
     */
    __privateAdd(this, _handleBackdropClick);
    __privateAdd(this, _boundBackdropClick, void 0);
    __privateAdd(this, _boundKeydown, void 0);
    /**
     * @private
     */
    __privateAdd(this, _emit, eventEmitter(this));
    this.width = "medium";
    this.heading = "";
    __privateSet(this, _boundBackdropClick, __privateMethod(this, _handleBackdropClick, handleBackdropClick_fn).bind(this));
    __privateSet(this, _boundKeydown, __privateMethod(this, _handleKeydown, handleKeydown_fn).bind(this));
  }
  /**
   * @private
   */
  static get scopedElements() {
    return {
      "hzn-heading": HznHeading,
      "hzn-icon-button": HznIconButton,
      "hzn-icon-close": HznIconClose
    };
  }
  /**
  * The inner button that dismisses the modal
  */
  get innerDismissButton() {
    return this.dismissButton ? this.dismissButton.innerButton : null;
  }
  connectedCallback() {
    super.connectedCallback();
    injectScrollLockStyles();
  }
  disconnectedCallback() {
    document.removeEventListener("keydown", __privateGet(this, _boundKeydown));
    document.removeEventListener("click", __privateGet(this, _boundBackdropClick));
  }
  show() {
    if (this.innerDialog) {
      this.innerDialog.setAttribute("aria-hidden", "false");
      this.innerDialog.showModal();
      document.body.setAttribute("data-scroll-lock", "");
      document.addEventListener("keydown", __privateGet(this, _boundKeydown));
      if (!this.notDismissible) {
        document.addEventListener("click", __privateGet(this, _boundBackdropClick));
      }
    }
  }
  hide(event) {
    if (this.innerDialog) {
      if (event) {
        event == null ? void 0 : event.preventDefault();
        event == null ? void 0 : event.stopImmediatePropagation();
        __privateGet(this, _emit).call(this, {
          type: "dismiss",
          // @ts-ignore
          callback() {
            document.removeEventListener("keydown", __privateGet(this, _boundKeydown));
            document.removeEventListener("click", __privateGet(this, _boundBackdropClick));
            document.body.removeAttribute("data-scroll-lock");
            this.innerDialog.setAttribute("aria-hidden", "true");
            this.innerDialog.close();
          }
        });
      } else {
        this.innerDialog.close();
        document.body.removeAttribute("data-scroll-lock");
      }
    }
  }
  render() {
    return html`<dialog
      class=${classMap({
      "is-width-large": this.width === "large",
      "is-width-medium": this.width === "medium",
      "is-width-small": this.width === "small"
    })}
      aria-modal="true"
      aria-hidden="true"
      aria-labelledby="heading"
    >
      ${this.heading || !this.notDismissible ? html`<header>
        <hzn-heading id="heading" size="small" as="h2">${this.heading}</hzn-heading>
        ${!this.notDismissible ? html`
          <hzn-icon-button label="Dismiss dialog." class="modal-dismiss-button" @click=${this.hide} square tone="neutral">
            <hzn-icon-close></hzn-icon-close>
          </hzn-icon-button>
        ` : nothing}
      </header>` : nothing}
      <div class="modal-content-container">
        <slot name="feature"></slot>
        <div class="modal-content">
          <slot></slot>
        </div>
      </div>
      <footer class="modal-actions">
        <slot name="actions"></slot>
      </footer>
    </dialog>`;
  }
}
_boundBackdropClick = new WeakMap();
_boundKeydown = new WeakMap();
_emit = new WeakMap();
_handleKeydown = new WeakSet();
handleKeydown_fn = function(event) {
  if (event.key === "Escape") {
    event.preventDefault();
    if (this.notDismissible) {
      return;
    } else {
      this.hide(event);
    }
  }
};
_handleBackdropClick = new WeakSet();
handleBackdropClick_fn = function(event) {
  if (event.composedPath()[0] === this.innerDialog) {
    this.hide(event);
  }
};
HznModal.styles = [ModalStyles];
__decorateClass([
  query("dialog")
], HznModal.prototype, "innerDialog", 2);
__decorateClass([
  query(".modal-dismiss-button")
], HznModal.prototype, "dismissButton", 2);
__decorateClass([
  property()
], HznModal.prototype, "width", 2);
__decorateClass([
  property()
], HznModal.prototype, "heading", 2);
__decorateClass([
  property({ type: Boolean, attribute: "not-dismissible" })
], HznModal.prototype, "notDismissible", 2);
export {
  HznModal
};
//# sourceMappingURL=modal.js.map
